module.exports = "<svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.83051 12L5.9661 7.83429L3.15254 12H0L4.38983 5.89714L0.220339 0H3.33898L6.0678 3.89143L8.74576 0H11.7119L7.57627 5.79429L12 12H8.83051Z\" fill=\"#f4c753\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/x.svg
// module id = 884
// module chunks = 0